const Select = ({
  label,
  name,
  register,
  error,
  isRequired,
  className = "",
  placeholder = "Select",
  type,
  value,
  id,
  hasicon,
  options = [],
  onChange,
  ...rest
}) => {
  return (
    <div className=" w-100">
      {label && (
        <label htmlFor={id} className="text-neutral-900 text-sm mb-2 fw-medium">
          {label}
          {isRequired && <span className="text-danger">*</span>}
        </label>
      )}
      {name && (
        <div className="position-relative">
          <select className={`${className} common-input`} id={id} {...register(name)} {...rest}>
            <option value="">{placeholder}</option>
            {options?.map((option) => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}
      {!name && (
        <div className="position-relative">
          <select className={`${className} common-input`} id={id} value={value} onChange={onChange} {...rest} autoComplete="off" >
            <option value="">{placeholder}</option>
            {Array.isArray(options) &&  options?.map((option) => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}
      {error && (
        <div className="mt-1">
          <p className="text-danger">{error?.message}</p>
        </div>
      )}
    </div>
  );
};

export default Select;
